import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { StorageService } from '../../../core/storage/storage.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SessionInfo, UserRegister } from 'src/app/shared/model/register.model';
import { CoreService } from 'src/app/core/services/core.service';
import i18next from 'i18next';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { RegisterModalComponent } from '../register-modal/register-modal.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ControlErrors } from 'src/app/shared/utils/generateError';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Collective } from 'src/app/shared/model/user.model';
import { ErrorWithGuideComponent } from 'src/app/shared/components/error-with-guide/error-with-guide.component';

@Component({
  standalone: true,
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    ErrorWithGuideComponent
  ]
})
export class EmailVerificationComponent implements OnInit, AfterViewInit {
  @ViewChild('autofocus') autofocus!: ElementRef<HTMLInputElement>;

  user!: UserRegister;

  spinner = false;
  code = '';
  errorMessage = '';
  resendCodeText = '';
  group = 'PSS';
  loginErrorMessage: string | null = null;
  showDownloadGuideLink = false;

  form: FormGroup = this.fb.group({
    code: ['', Validators.required]
  });
  modalContent?: NgbModalRef;

  constructor(
    private storageService: StorageService,
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router,
    private modalConfig: NgbModal,
    private controlErrors: ControlErrors,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.user = this.storageService.get('userRegister');
    if (!this.user || this.user.nis === '' || this.user.password === '') {
      this.router.navigateByUrl('login');
    }

    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['group']) {
        this.group = queryParams['group'];
      }
    });
  }

  ngAfterViewInit() {
    this.autofocus.nativeElement.focus();
  }

  controlInput(input: string): boolean {
    return (
      this.form?.controls[input]?.invalid && this.form?.controls[input]?.touched
    );
  }
  codeVerification() {
    this.spinner = true;

    const emailCode = this.form.value.code.trim();
    this.coreService
      .confirmSignup(this.user.nis, this.user.password, emailCode)
      .subscribe({
        next: () => {
          this.spinner = false;
          this.coreService
            .signin(
              this.user.nis,
              this.user.password,
              undefined,
              Collective[this.group as keyof typeof Collective]
            )
            .subscribe({
              next: (res) => {
                if (res.qrCodeResponseDTO) {
                  const sessionInfo: SessionInfo = {
                    qrCodeResponseDTO: {
                      emailCode: emailCode,
                      qrCode: res.qrCodeResponseDTO.qrCode,
                      session: res.qrCodeResponseDTO.session,
                      secretCode: res.qrCodeResponseDTO.secretCode
                    },
                    smsResponseDTO: null
                  };
                  this.storageService.set('sessionInfo', sessionInfo);
                  this.router.navigateByUrl('/register/mfa-authentication');
                } else {
                  this.router.navigateByUrl('login');
                }
              },
              error: (err: HttpErrorResponse) => {
                this.showDownloadGuideLink = false;
                if (err.status === 406 && err.error?.message === '5005') {
                  this.errorMessage = this.controlErrors.generateError(
                    err.error?.message,
                    i18next.t('categoryError')
                  );
                } else if (
                  err.status === 406 &&
                  err.error?.message === '5003'
                ) {
                  this.errorMessage = this.controlErrors.generateError(
                    err.error?.message,
                    i18next.t('errorNoPhones')
                  );
                } else if (err.status === 412) {
                  this.errorMessage = this.controlErrors.generateError(
                    err.error?.message,
                    i18next.t('loginNoPss')
                  );
                } else {
                  this.errorMessage = this.controlErrors.generateError(
                    err.error?.message,
                    i18next.t('genericErr')
                  );
                  this.loginErrorMessage = i18next.t('loginAdditionalMessage');
                  this.showDownloadGuideLink = true;
                }
              }
            });
        },
        error: (e: HttpErrorResponse) => {
          this.spinner = false;
          if (e.error.message === '5004') {
            this.modalContent = this.modalConfig.open(FeedbackModalComponent, {
              windowClass: 'register-modal',
              centered: true,
              backdrop: 'static'
            });
            this.modalContent.componentInstance.text =
              this.controlErrors.generateError(
                e.error?.message,
                i18next.t('ErrorCode')
              );
            this.modalContent.componentInstance.redirect = false;
          } else {
            this.errorMessage = this.controlErrors.generateError(
              e.error?.message,
              i18next.t('genericErr')
            );
            this.showDownloadGuideLink = true;
          }
        }
      });
  }

  resendCode() {
    this.coreService.resendConfirmationCode(this.user.nis).subscribe({
      next: () => {
        this.resendCodeText = i18next.t('emailVerificationResendFeedbackOk');
      },
      error: (e: HttpErrorResponse) => {
        this.resendCodeText = this.controlErrors.generateError(
          e.error?.message,
          i18next.t('emailVerificationResendFeedbackKo')
        );
      }
    });
  }
}
